<template>
  <SkeletonLoader>
    <div class="campaigns-skeleton">
      <!-- Header: title + New Campaign button -->
      <div class="campaigns-skeleton__header">
        <div class="sk-line sk-line--title" style="width: 30%;"></div>
        <div class="sk-rect" style="width: 160px; height: 38px; border-radius: 6px;"></div>
      </div>

      <!-- Sub-navigation tabs -->
      <div class="campaigns-skeleton__nav">
        <div class="sk-rect" style="width: 80px; height: 32px; border-radius: 6px;"></div>
        <div class="sk-rect" style="width: 60px; height: 32px; border-radius: 6px;"></div>
        <div class="sk-rect" style="width: 70px; height: 32px; border-radius: 6px;"></div>
        <div class="sk-rect" style="width: 80px; height: 32px; border-radius: 6px;"></div>
        <div class="sk-rect" style="width: 70px; height: 32px; border-radius: 6px;"></div>
      </div>

      <!-- Stats row: 4 stat cards -->
      <div class="campaigns-skeleton__stats">
        <div v-for="i in 4" :key="'stat-' + i" class="campaigns-skeleton__stat-card">
          <div class="sk-circle sk-circle--md"></div>
          <div class="campaigns-skeleton__stat-text">
            <div class="sk-line sk-line--lg" :style="{ width: statNumberWidths[i] }"></div>
            <div class="sk-line sk-line--sm" :style="{ width: statLabelWidths[i] }"></div>
          </div>
        </div>
      </div>

      <!-- Filter bar: search + view toggle -->
      <div class="campaigns-skeleton__filters">
        <div class="sk-rect" style="width: 250px; height: 38px; border-radius: 6px;"></div>
        <div class="sk-rect" style="width: 80px; height: 38px; border-radius: 6px;"></div>
      </div>

      <!-- Campaign rows -->
      <div v-for="i in 5" :key="'campaign-' + i" class="campaigns-skeleton__row">
        <div class="sk-circle sk-circle--lg" style="flex-shrink: 0;"></div>
        <div class="sk-col" style="flex: 3;">
          <div class="sk-line" :style="{ width: titleWidths[i] }"></div>
          <div class="sk-line sk-line--sm" :style="{ width: subtitleWidths[i] }"></div>
        </div>
        <div class="sk-col campaigns-skeleton__row-stats" style="flex: 2;">
          <div class="sk-line sk-line--sm" :style="{ width: stat1Widths[i] }"></div>
          <div class="sk-line sk-line--sm" :style="{ width: stat2Widths[i] }"></div>
        </div>
        <div class="campaigns-skeleton__row-badge" style="flex-shrink: 0;">
          <div class="sk-rect" style="width: 72px; height: 24px; border-radius: 12px;"></div>
        </div>
      </div>
    </div>
  </SkeletonLoader>
</template>

<script>
import SkeletonLoader from '@/components/SkeletonLoader.vue';

export default {
  name: 'CampaignsSkeleton',
  components: { SkeletonLoader },
  data() {
    return {
      statNumberWidths: { 1: '50%', 2: '40%', 3: '55%', 4: '45%' },
      statLabelWidths: { 1: '70%', 2: '60%', 3: '75%', 4: '65%' },
      titleWidths: { 1: '65%', 2: '80%', 3: '55%', 4: '70%', 5: '60%' },
      subtitleWidths: { 1: '45%', 2: '55%', 3: '40%', 4: '50%', 5: '35%' },
      stat1Widths: { 1: '60%', 2: '50%', 3: '70%', 4: '55%', 5: '65%' },
      stat2Widths: { 1: '45%', 2: '55%', 3: '40%', 4: '50%', 5: '45%' },
    };
  }
}
</script>

<style lang="scss" scoped>
.campaigns-skeleton {
  padding: 20px;
}

.campaigns-skeleton__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.campaigns-skeleton__nav {
  display: flex;
  gap: 8px;
  margin-bottom: 24px;
  border-bottom: 1px solid #e2e8f0;
  padding-bottom: 12px;
}

.campaigns-skeleton__stats {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-bottom: 24px;
}

.campaigns-skeleton__stat-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}

.campaigns-skeleton__stat-text {
  flex: 1;
  min-width: 0;
}

.campaigns-skeleton__filters {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.campaigns-skeleton__row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 12px;
  border-bottom: 1px solid #f1f5f9;
}

.campaigns-skeleton__row-stats {
  min-width: 0;
}

.campaigns-skeleton__row-badge {
  min-width: 72px;
  text-align: right;
}

/* Tablet: stat cards 2x2 */
@media (max-width: 1024px) {
  .campaigns-skeleton__stats {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* Mobile */
@media (max-width: 768px) {
  .campaigns-skeleton {
    padding: 12px;
  }

  .campaigns-skeleton__stats {
    grid-template-columns: 1fr;
  }

  .campaigns-skeleton__nav {
    flex-wrap: wrap;
  }

  .campaigns-skeleton__filters {
    flex-direction: column;
    gap: 8px;
    align-items: stretch;

    .sk-rect {
      width: 100% !important;
    }
  }

  .campaigns-skeleton__row-stats {
    display: none;
  }

  .campaigns-skeleton__row-badge {
    margin-left: auto;
  }
}
</style>
